import { useState } from 'react';
import { uiText } from '../../i18n';
import { artworkUrl } from './studio-art-model';
import { StudioSheet } from './StudioSheet';
import '../../legacy/bot-people.css';
export interface StudioPersonChoice {
  value: string;
  name: string;
  image?: string | null;
  disabled?: boolean;
}
/** Общий ряд лиц и полный лист выбора; загрузку каталога выполняет владеющий экран. */
export function StudioPeopleRow({
  choices,
  value,
  label,
  disabled,
  onPick,
  selectedValues,
  open: controlledOpen,
  onOpenChange,
  keepOpen = false,
  compatSelect = true,
}: {
  choices: StudioPersonChoice[];
  value: string;
  label: string;
  disabled: boolean;
  onPick(value: string): void;
  selectedValues?: string[];
  open?: boolean;
  onOpenChange?(open: boolean): void;
  keepOpen?: boolean;
  compatSelect?: boolean;
}) {
  const [ownOpen, setOwnOpen] = useState(false),
    [query, setQuery] = useState('');
  const open = controlledOpen ?? ownOpen;
  const setOpen = (value: boolean) => {
    if (onOpenChange) onOpenChange(value);
    else setOwnOpen(value);
  };
  const picked = (choice: StudioPersonChoice) => (selectedValues ? selectedValues.includes(choice.value) : choice.value === value);
  const card = (choice: StudioPersonChoice) => (
    <button
      key={choice.value}
      type="button"
      className={`ps-fc${picked(choice) ? ' on' : ''}`}
      aria-pressed={picked(choice)}
      disabled={disabled || choice.disabled}
      onClick={() => {
        onPick(choice.value);
        if (!keepOpen) setOpen(false);
      }}
    >
      <span className="ps-fo">
        <span className="ps-fi" aria-hidden="true">
          {artworkUrl(choice.image) ? (
            <img src={artworkUrl(choice.image)!} alt="" />
          ) : (
            <span className="ini">{choice.name.slice(0, 1)}</span>
          )}
        </span>
        <i className="ck" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="m5 12 4 4L19 6" />
          </svg>
        </i>
      </span>
      <b>{choice.name}</b>
    </button>
  );
  return (
    <div className="ps-face studio-native-people">
      <div className="ps-fr" role="group" aria-label={`${uiText(label)} · ${uiText('Люди и персонажи')}`}>
        {choices.slice(0, 8).map(card)}
        {choices.length > 8 && (
          <button type="button" className="ps-fc" disabled={disabled} onClick={() => setOpen(true)}>
            <span className="ps-fo">…</span>
            <b>{uiText('Все')}</b>
          </button>
        )}
      </div>
      {compatSelect && (
        <select
          className="studio-native-compat-select"
          tabIndex={-1}
          aria-label={uiText(label)}
          value={value}
          disabled={disabled}
          onChange={event => onPick(event.target.value)}
        >
          <option value="">{uiText('Выберите')}</option>
          {choices.map(choice => (
            <option key={choice.value} value={choice.value} disabled={choice.disabled}>
              {choice.name}
            </option>
          ))}
        </select>
      )}
      {open && (
        <StudioSheet title={label} onClose={() => setOpen(false)}>
          <h2>{uiText(label)}</h2>
          <label className="search">
            <input
              type="search"
              value={query}
              onChange={event => setQuery(event.target.value)}
              placeholder={uiText('Поиск')}
              aria-label={uiText('Поиск')}
            />
          </label>
          <div className="studio-native-person-grid">
            {choices.filter(choice => choice.name.toLocaleLowerCase().includes(query.toLocaleLowerCase())).map(card)}
          </div>
          {keepOpen && (
            <button type="button" className="btn" onClick={() => setOpen(false)}>
              {uiText('Готово')}
            </button>
          )}
        </StudioSheet>
      )}
    </div>
  );
}
